import React, { ReactElement, useState, useEffect } from "react"
import { Typography, makeStyles } from "@material-ui/core"
import { useParams } from "react-router-dom"

/**
 * Prop definition for the PanelsTitle component
 *
 * @interface PanelsTitleProps
 */
interface PanelsTitleProps {
	customTitle: string
	useCustomTitle: boolean
}

// Canvas title styles
const useStyles = makeStyles((theme) => ({
	caption: {
		lineHeight: 1.2,
	},
	title: {
		marginBottom: theme.spacing(2),
	},
	noTitle: {
		color: theme.palette.grey[600],
	},
}))

/**
 * Displays the compiled canvas title or the custom title
 *
 * @export
 * @param {PanelsTitleProps} {
 * 	type,
 * 	timeframe,
 * 	startDate,
 * 	endDate,
 * }
 * @returns {ReactElement}
 */
export default React.memo(function PanelsTitle({
	customTitle,
	useCustomTitle,
}: PanelsTitleProps): ReactElement {
	const cls = useStyles()
	const { id } = useParams<any>()
	const [comp, setComp] = useState<"h3" | "h1">("h3")

	useEffect(() => {
		setComp(typeof id === "undefined" ? "h3" : "h1")
	}, [id, setComp])

	/**
	 * Placeholder component when there is no custom title
	 *
	 * @returns {ReactElement}
	 */
	function AddTitle(): ReactElement {
		return (
			<Typography
				variant="h4"
				component="span"
				className={`${cls.title} ${cls.noTitle}`}
			>
				Dodaj naslov ispod
			</Typography>
		)
	}

	function generateTitle(): ReactElement {
		return (
			<Typography
				variant="h4"
				component="span"
				className={`${cls.title} ${cls.noTitle}`}
			>
				Dodaj naslov ispod
			</Typography>
		)
	}

	return (
		<>
			<Typography
				style={{ marginBottom: 0 }}
				variant="h5"
				className={cls.title}
				component={comp}
			>
				{useCustomTitle ? customTitle || <AddTitle /> : generateTitle()}
			</Typography>
		</>
	)
})
